import React, { useEffect, useState } from "react";
import {
  Box,
  useMediaQuery,
  Typography,
  useTheme,
  Divider,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import "../../App.scss";
import CloseIcon from "@mui/icons-material/Close";
import SearchMedicationAutoComplete from "pages/SearchMedication/SearchMedicationAutoComplete";
import SearchMainTemplate from "components/SearchMainTemplate";
import MedicationDetailsContainer from "./MedicationDetailsContainer";
import { gaugeActions, homeActions } from "actions";
import { connect } from "react-redux";
import InsuranceContainer from "./InsuranceContainer";
import { Helmet } from "react-helmet";
import BrandedCouponView from "./BrandedCouponView";
import GenericListAndCouponView from "./GenericListAndCouponView";
import { gaugeService } from "../../services/gauge.service";
import SmallModalViewTemplate from "./SmallModalViewTemplate";
import ForwardToInbox from "assets/images/coupon-share.png";
import ShareHCPApp from "pages/home/ShareHCPApp";

const SearchMedication = (props) => {
  const {
    getProductPartialSearch,
    resetInfo,
    selectedProduct,
    getProductDetails,
    productDetailId,
    productDetailIsProgress,
    zipData,
    getDiscountPrice,
    getRetailPrice,
    updateRetailPrice,
    copayPrice,
    getAlternateList,
    getCouponPrice,
    retailData,
    discountData,
    getCopayPrice,
    selectedInsurance,
    resetData,
    resetBrandDetails,
    appQuantity,
    resetZipStatus,
    selectedQuantity,
    updateGTMDataLayer,
    gtmInfo,
    match,
    jwtToken,
    saveSelectedProduct,
    organizationInfo,
    genericDetails,
    brandDetailsNew,
    couponPriceReset,
    copayPriceIsProgress,
    authData,
    // saveDosage,
    // saveForm,
    // saveQuantity,
  } = props;

  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };

  const isFromHome = props.location.state?.isFromHomeGauge;
  const optionView = isFromHome ? "gauge" : "showList";
  const matches500MaxWidth = useMediaQuery("(max-width:500px)");
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesLargeWidth = useMediaQuery("(max-width:1366px)");

  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );
  const [viewType, setViewType] = useState(optionView);
  const [showGauge, setShowGauge] = useState(true);
  const [typeOfProduct, setTypeOfProduct] = useState(null);
  const [couponOrGenericListTitle, setCouponOrGenericListTitle] =
    useState(null);
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const [gaugeInit, setGaugeInit] = useState(false);
  const [openSearchButton, setOpenSearchButton] = React.useState(false);
  const [insuraceData, setInsuraceData] = React.useState(false);
  const [editFromInsurace, setEditFromInsurace] = React.useState(false);
  const [savingsBtnAutoForward, setSavingsBtnAutoForward] = useState(true);
  const [isFromCouponEligibity, setIsFromCouponEligibity] = useState(false);
  const [alternateView, setAlternateView] = useState(false);
  const [selectedPharmacyData, setSelectedPharmacyData] = useState(null);
  const [prevSelectedCouponData, setPrevSelectedCouponData] = useState(null);
  const [otherPharmacyData, setOtherPharmacyData] = useState([]);
  const [showPharmacyListPopup, setShowPharmacyListPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showShareHCPPopup, setShowShareHCPPopup] = useState(false);

  const showProductDetailSelectionFlag =
    organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
    "y";
  const showGaugeFlag =
    organizationInfo?.organizationOptionJson?.showGaugeFlag?.toLowerCase() ===
    "y";
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const isSinglePharmacy =
    authData?.organization?.restrictPharmacyGroupIdList?.length === 1 &&
    authData?.organization?.organizationOptionJson?.restrictPharmacyGroupFlag?.toLowerCase() ===
      "y";

  useEffect(() => {
    if (!openSearchButton) {
      setInsuraceData(selectedInsurance);
    }
  }, [openSearchButton, selectedInsurance]);

  const getInsuranceId = () => {
    let insId = storedInsuranceData?.id;

    if (!insId && insId !== 0) {
      insId = defaultInsuranceId;
    }

    return insId;
  };

  const discountAndRetail = (id, zipCode) => {
    if (id && id !== "" && zipCode) {
      if (selectedProduct.type.toLowerCase() === "b") {
        getRetailPrice({
          productID: id,
          zipCode: zipCode,
          quantity: appQuantity,
        });
      } else {
        updateRetailPrice({
          zipCode: null,
          regularPrice: "",
        });
      }
    } else if (!zipCode) {
      setGaugeInit(false);
    }
  };

  useEffect(() => {
    props.setValue(1);
    resetBrandDetails();
    // window.dataLayer.push(tagManagerArgs);
    return () => {
      resetData("productReset");
      resetZipStatus();
      saveSelectedProduct("");
      setGaugeInit(false);
      setOpenSearchButton(false);
      updateGTMDataLayer({
        event: "Nav_search_for_medication",
        screen_referrer: "Search for medication",
      });
    };
  }, []);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  useEffect(() => {
    if (jwtToken && match?.params?.name) {
      getProductPartialSearch(match?.params?.name);
    }
  }, [jwtToken]);

  useEffect(() => {
    if (selectedProduct) {
      setGaugeInit(true);
      setAlternateView(false);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct && resetInfo.type === "productReset") {
      if (!productDetailIsProgress) {
        getProductDetails(selectedProduct.productId);
      }
    } else if (
      gaugeInit &&
      (resetInfo.type === "insuranceReset" ||
        resetInfo.type === "zipCodeReset" ||
        resetInfo.type === "quantityReset")
    ) {
      if (!showProductDetailSelectionFlag && !showGaugeFlag) {
        setTimeout(() => {
          getCouponPrice({
            productDetailId: productDetailId,
            insuranceId: getInsuranceId(),
            zipCode: storedZipData?.zipCode || zipData?.zipCode,
            quantity: appQuantity,
          });
        }, 1000);
      } else if (showProductDetailSelectionFlag && !showGaugeFlag) {
        if (selectedProduct.type.toLowerCase() === "b") {
          updateRetailPrice({
            zipCode: null,
            regularPrice: "",
          });
        } else {
          getCopayPrice({
            productDetailId: productDetailId,
            insuranceId: getInsuranceId(),
          });
        }
      } else {
        discountAndRetail(
          productDetailId,
          storedZipData?.zipCode || zipData?.zipCode
        );
      }
    }
  }, [resetInfo.type, gaugeInit, selectedProduct]);

  useEffect(() => {
    if (zipData?.zipCode && !gaugeInit && !openSearchButton) {
      setGaugeInit(true);
    }
  }, [zipData]);

  useEffect(() => {
    if (retailData && Object.keys(retailData).length) {
      setTimeout(
        () => {
          getDiscountPrice({
            productID: productDetailId,
            zipCode: storedZipData?.zipCode || zipData?.zipCode,
            quantity: appQuantity,
          });
        },
        selectedProduct.type.toLowerCase() === "b" ? 100 : 0
      );
    }
  }, [retailData]);

  useEffect(() => {
    if (
      selectedQuantity.productDetailId &&
      copayPrice &&
      Object.keys(copayPrice).length &&
      (storedZipData?.zipCode || zipData?.zipCode)
    ) {
      if (copayPrice?.alternateFlag === "Y") {
        setSavingsBtnAutoForward(false);
        getAlternateList({
          productDetailId: selectedQuantity.productDetailId,
          insuranceId: getInsuranceId(),
          zipCode: storedZipData?.zipCode || zipData?.zipCode,
        });
        setTimeout(() => {
          setGaugeInit(false);
        }, 300);
      } else {
        setTimeout(
          () => {
            getCouponPrice({
              productDetailId: selectedQuantity.productDetailId,
              insuranceId: getInsuranceId(),
              zipCode: storedZipData?.zipCode || zipData.zipCode,
              quantity: appQuantity,
            });
          },
          !showGaugeFlag ? 2000 : 0
        );
      }
    }
  }, [copayPrice]);

  const copayExecution = (timeout = 500) => {
    if (
      retailData &&
      Object.keys(retailData).length &&
      discountData &&
      Object.keys(discountData).length &&
      storedInsuranceData &&
      productDetailId
    ) {
      setTimeout(() => {
        getCopayPrice({
          productDetailId: productDetailId,
          insuranceId: getInsuranceId(),
        });
      }, timeout);
    } else if (
      selectedProduct &&
      selectedProduct?.type.toLowerCase() === "g" &&
      discountData &&
      Object.keys(discountData).length &&
      storedInsuranceData &&
      productDetailId
    ) {
      setTimeout(() => {
        getCopayPrice({
          productDetailId: productDetailId,
          insuranceId: getInsuranceId(),
        });
      }, timeout);
    } else if (
      selectedProduct &&
      productDetailId &&
      discountData &&
      Object.keys(discountData).length &&
      (storedZipData?.zipCode || zipData?.zipCode) &&
      gaugeInit &&
      !(defaultInsuranceId || storedInsuranceData?.id)
    ) {
      setGaugeInit(false);
    }
  };

  useEffect(() => {
    let copayTriggerFlag =
      !openSearchButton &&
      !copayPriceIsProgress &&
      !Object.keys(copayPrice).length;
    if (copayTriggerFlag) {
      copayExecution();
    }
  }, [retailData?.regularPrice, discountData]);

  useEffect(() => {
    if (!copayPriceIsProgress) {
      copayExecution(0);
      couponPriceReset();
    }
  }, [insuraceData?.name]);

  const getPharmacyData = async (selectedCouponData, alternate) => {
    setPrevSelectedCouponData(selectedCouponData);
    setLoading(true);
    const pharmacyApiData = await gaugeService?.getGenericList({
      productDetailId: selectedCouponData?.productDetailId,
      insuranceId: getInsuranceId(),
      zipCode: storedZipData?.zipCode || zipData?.zipCode,
      quantity: alternate ? 0 : appQuantity,
      type: "P",
    });
    const pharmacyData = pharmacyApiData?.data;

    await setOtherPharmacyData(pharmacyData?.otherPharmacies);
    if (pharmacyData?.favoritePharmacyAvailableFlag === "Y") {
      await setSelectedPharmacyData(pharmacyData?.favoritePharmacy);
      await setShowPharmacyListPopup(false);
      setShowGauge(false);
    }
    if (pharmacyData?.favoritePharmacyAvailableFlag === "N") {
      await setShowPharmacyListPopup(true);
    }
    setLoading(false);
  };

  const handleGaugeAndCouponView = async (
    type,
    alternate = false,
    selectedCouponData = {}
  ) => {
    setTypeOfProduct(type);
    setAlternateView(alternate);
    if (type === "couponDetails") {
      setShowGauge(false);
    } else if (type === "genericList" && isSinglePharmacy) {
      onSelectPharmacy(selectedCouponData);
    } else if (
      type === "genericList" &&
      prevSelectedCouponData?.productDetailId !==
        selectedCouponData?.productDetailId
    ) {
      getPharmacyData(selectedCouponData, alternate);
    } else {
      const favPharGroupId = Number(localStorage.getItem("pharmacyGroupId"));
      if (favPharGroupId) {
        let pharmacyData = null;
        if (selectedPharmacyData?.pharmacyGroupId === favPharGroupId) {
          pharmacyData = { ...selectedPharmacyData };
        } else {
          pharmacyData = otherPharmacyData?.filter(
            (item) => item?.pharmacyGroupId === favPharGroupId
          )[0];
        }
        if (pharmacyData) {
          await setSelectedPharmacyData(pharmacyData);
          setShowGauge(false);
        } else {
          getPharmacyData(selectedCouponData, alternate);
        }
      } else {
        setShowPharmacyListPopup(true);
      }
    }
  };

  const displaySavingsTxt = (item) => {
    let txt = null;

    if (item?.pharmacyType === "M") {
      txt = "BEST MAIL PRICE!";
    } else if (item?.lowestPrice === "Y") {
      txt = "BEST PRICE!";
    }
    return (
      <Typography
        variant={
          txt === "BEST PRICE!" || txt === "BEST MAIL PRICE!"
            ? "h3LatoBoldNew"
            : ""
        }
        style={{
          display: "flex",
          justifyContent: "end",
          fontSize: isHCPTemplate ? (matches ? "10px" : "14px") : undefined,
        }}
      >
        {txt === "BEST PRICE!" || txt === "BEST MAIL PRICE!" ? (
          <div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              ${item.price?.toFixed(2)}
            </div>{" "}
            <div>{txt}</div>
          </div>
        ) : (
          <>${item.price?.toFixed(2)}</>
        )}
      </Typography>
    );
  };

  const renderLogoView = (item) => {
    if (item && item.logoURL) {
      return (
        <div>
          <img
            src={item && item.logoURL}
            alt="logo"
            style={{
              width: matchesMinWidth
                ? "80%"
                : matchesLargeWidth
                ? "60%"
                : "35%",
            }}
          />
        </div>
      );
    } else {
      return (
        <Typography
          variant="h3LatoBlack"
          sx={{
            fontSize: matchesMinWidth ? "15px" : undefined,
            height: matchesMinWidth ? "60px" : "80px",
            alignItems: "center",
            display: "flex",
          }}
          component="span"
        >
          {item.name || item.pharmacyName}
        </Typography>
      );
    }
  };

  const onSelectPharmacy = async (item) => {
    await setSelectedPharmacyData(item);
    if (isHCPTemplate) {
      setShowGauge(true);
      setShowShareHCPPopup(true);
      setShowPharmacyListPopup(true);
    } else {
      setShowGauge(false);
      setShowPharmacyListPopup(false);
    }
  };

  const renderPharmacyListDiaglog = () => {
    return (
      <Box
        sx={{
          minHeight: "50px",
          maxHeight: "380px",
          overflowY: "auto",
          marginBottom: "1rem",
          padding: matches ? "0px" : "10px",
        }}
      >
        <Divider />
        {otherPharmacyData &&
          otherPharmacyData?.map((item, index) => {
            return (
              <>
                <Box
                  sx={{
                    width: "100%",
                    cursor: "pointer",
                    padding: "10px",
                  }}
                  onClick={async () => {
                    onSelectPharmacy(item);
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        height: "50px",
                      }}
                    >
                      {renderLogoView(item)}
                    </Box>
                    {isHCPTemplate && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "50%",
                          //height: "50px",
                        }}
                      >
                        <img
                          alt="Text Coupon"
                          onClick={() => {
                            // if (isHCPTemplate) {
                            //   setSelectedHCPPharmacyGroupId(
                            //     selectedPharmacy?.pharmacyGroupId
                            //   );
                            //   setShowShareHCPPopup(true);
                            // }
                          }}
                          style={{
                            cursor: "pointer",
                            width: "43%",
                          }}
                          src={ForwardToInbox}
                        />
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        // height: "40px",
                      }}
                    >
                      <Typography
                        variant="h3LatoBold"
                        sx={{
                          //color: item?.lowestPrice === "N" ? "#003d4c" : "#03952a",
                          fontSize: matches ? "14px" : undefined,
                          width: "100%",
                        }}
                      >
                        {displaySavingsTxt(item, index)}{" "}
                      </Typography>
                    </Box>
                  </Box>
                  {item.pharmacyType !== "M" && (
                    <Box
                      sx={{
                        display: "flex",
                      }}
                    >
                      <Typography
                        variant="h4LatoMedium"
                        component="div"
                        sx={{
                          color: theme.palette.common.textGrey2,
                          width: "90%",
                        }}
                      >
                        {item && item.distance?.toFixed(2)} mi &nbsp;
                      </Typography>
                    </Box>
                  )}
                </Box>
                <Divider />
              </>
            );
          })}
      </Box>
    );
  };

  return (
    <SearchMainTemplate
      hideBGColor={true}
      minHeightValue="600px"
      marginbottom={matches500MaxWidth && showGauge ? "70px" : "40px"}
      viewType={viewType}
      showGauge={showGauge}
      // pageTitle="Search for Medication"
    >
      <Helmet>
        <title>
          Search for Medication Savings and Discounts |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="Description"
          content="How Cuverd works to give you discounts and savings on your prescription medications."
        />
        <meta
          property="og:title"
          content="Search for Medication Savings and Discounts | Cuverd®"
        />
        <meta
          property="og:description"
          content="How Cuverd works to give you discounts and savings on your prescription medications."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/search-medications"
          hrefLang="en-us"
        />
        <link
          rel="canonical"
          href="https://www.cuverd.com/search-medications"
        />
      </Helmet>
      {/* Gauge view related screens */}
      <Box
        sx={{
          display: "block",
          height: "100%",
          visibility: showGauge ? "visible" : "hidden",
        }}
      >
        {!openSearchButton && (
          <>
            <SearchMedicationAutoComplete
              searchOnFocus={(value) => {
                setViewType(value);
                if (value !== "gauge") {
                  setGaugeInit(false);
                  setSavingsBtnAutoForward(false);
                }
              }}
              zIndex={viewType === "insurance" ? -4 : 15}
              openList={viewType === "showList" ? true : false}
              match={match}
              viewType={viewType}
              setGaugeInit={setGaugeInit}
              gaugeInit={gaugeInit}
            />
          </>
        )}
        <Box
          sx={{
            visibility:
              viewType === "gauge" && showGauge ? "visible" : "hidden",
            position:
              viewType === "gauge" && showGauge ? "relative" : "absolute",
          }}
        >
          <MedicationDetailsContainer
            setPrevSelectedCouponData={setPrevSelectedCouponData}
            match={match}
            showGauge={showGauge}
            setGaugeInit={setGaugeInit}
            gaugeInit={gaugeInit}
            isFromCouponEligibity={isFromCouponEligibity}
            openInsurance={(value) => {
              if (value === "insurance" || value === "select_insurance") {
                setGaugeInit(false);
                setOpenSearchButton(true);
                setSavingsBtnAutoForward(false);
                setViewType("insurance");
                setIsFromCouponEligibity(
                  value === "select_insurance" ? true : false
                );
              } else {
                setViewType(value);
              }
            }}
            handleGaugeAndCouponView={handleGaugeAndCouponView}
            setCouponOrGenericListTitle={setCouponOrGenericListTitle}
            openSearchButton={openSearchButton}
            setOpenSearchButton={setOpenSearchButton}
            setShowGauge={setShowGauge}
            editFromInsurace={editFromInsurace}
            setEditFromInsurace={setEditFromInsurace}
            setSavingsBtnAutoForward={setSavingsBtnAutoForward}
            savingsBtnAutoForward={savingsBtnAutoForward}
            alternateView={alternateView}
            setAlternateView={setAlternateView}
          />
        </Box>
        {showProductDetailSelectionFlag ? (
          <Box sx={{ display: viewType === "insurance" ? "block" : "none" }}>
            <InsuranceContainer
              isFromCouponEligibity={isFromCouponEligibity}
              closeInsurance={(value, isFromCancel = false) => {
                setViewType(value);
                if (isFromCouponEligibity) {
                  setOpenSearchButton(false);
                  setIsFromCouponEligibity(false);
                  if (
                    !isFromCancel ||
                    (isFromCancel &&
                      !genericDetails?.memberId &&
                      !brandDetailsNew?.memberId)
                  ) {
                    setSavingsBtnAutoForward(true);
                  }
                }
              }}
              insuranceZIndex={viewType === "insurance" ? 1 : -1}
            />
          </Box>
        ) : null}
      </Box>
      {/* details related screens */}
      <Box
        sx={{
          display: "block",
          position: !showGauge ? "relative" : "absolute",
          top: 0,
          left: 0,
          right: 0,
          visibility: !showGauge ? "visible" : "hidden",
        }}
      >
        {!showGauge && typeOfProduct && typeOfProduct === "genericList" ? (
          <GenericListAndCouponView
            {...props}
            showGauge={showGauge}
            searchGaugeView={true}
            couponOrGenericListTitle={couponOrGenericListTitle}
            backToSearchGauge={() => {
              setShowGauge(true);
              const favPharGroupId = Number(
                localStorage.getItem("pharmacyGroupId")
              );
              if (!favPharGroupId && !isHCPTemplate) {
                if (!prevSelectedCouponData) {
                  handleGaugeAndCouponView(
                    typeOfProduct,
                    alternateView,
                    selectedPharmacyData?.productDetailId
                      ? selectedPharmacyData
                      : {
                          ...selectedPharmacyData,
                          productDetailId: productDetailId,
                        }
                  );
                } else {
                  setShowPharmacyListPopup(true);
                }
              }
            }}
            selectedPharmacy={selectedPharmacyData}
            setPrevSelectedCouponData={setPrevSelectedCouponData}
            openSearchSettings={() => {
              setSavingsBtnAutoForward(false);
              setShowGauge(true);
              setOpenSearchButton(true);
              setGaugeInit(false);
              setEditFromInsurace(true);
            }}
            alternateView={alternateView}
          />
        ) : null}

        {!showGauge && typeOfProduct && typeOfProduct !== "genericList" ? (
          <BrandedCouponView
            {...props}
            searchGaugeView={true}
            showGauge={showGauge}
            backToSearchGauge={() => setShowGauge(true)}
            openSearchSettings={() => {
              setSavingsBtnAutoForward(false);
              setShowGauge(true);
              setOpenSearchButton(true);
              setGaugeInit(false);
              setEditFromInsurace(true);
            }}
          />
        ) : null}
      </Box>

      {loading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress
            style={{ color: theme?.palette?.secondary?.main }}
          />
        </Backdrop>
      ) : null}

      {showPharmacyListPopup && (
        <SmallModalViewTemplate
          onCancelAlternatives={() => {
            setShowPharmacyListPopup(false);
          }}
        >
          <Box sx={{ textAlign: "center", display: "flex" }}>
            <Typography
              variant="h2LatoBlackNew"
              sx={{
                width: matchesMinWidth ? "90%" : "95%",
                //color: "#03952a",
                lineHeight: "1",
                fontSize: matchesMinWidth ? "18px" : "24px",
                height: "40px",
              }}
            >
              Select Pharmacy
            </Typography>

            <Typography
              variant="h2LatoBlack"
              sx={{
                cursor: "pointer",
                lineHeight: "1",
                fontSize: matchesMinWidth ? "18px" : "24px",
              }}
              onClick={() => {
                setShowPharmacyListPopup(false);
              }}
            >
              <CloseIcon />
            </Typography>
          </Box>

          {renderPharmacyListDiaglog()}
          <Box
            mt={matches ? 2 : 2}
            mb={matches ? 2 : 2}
            sx={{ textAlign: "center" }}
          >
            <Typography variant="h5LatoRegular" sx={{ color: "#000" }}>
              All product and company names referenced herein are trademarks of
              their respective owners.
            </Typography>
          </Box>
        </SmallModalViewTemplate>
      )}
      {showShareHCPPopup && (
        <ShareHCPApp
          setShowSharePopup={setShowShareHCPPopup}
          shareCoupon={showShareHCPPopup}
          shareApp={false}
          couponData={
            selectedPharmacyData?.productDetailId
              ? selectedPharmacyData
              : {
                  ...selectedPharmacyData,
                  productDetailId: productDetailId,
                }
          }
        />
      )}
    </SearchMainTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    selectedProduct: state.home.selectedProduct,
    refreshToken: state.authentication.refreshToken,
    jwtToken: state.authentication.jwtToken,
    authData: state.authentication.authData,
    productDetailId: state.productDetails.productDetailId,
    productDetailIsProgress: state.productDetails.isProgress,
    appQuantity: state.productDetails.appQuantity,
    selectedQuantity: state.productDetails.selectedQuantity,
    productsSearchList: state.productSearchList.data,
    topProductsList: state.topProducts.data,
    zipData: state.zipData.data,
    retailProgress: state.retailPrice.isProgress,
    discountProgress: state.discountPrice.isProgress,
    selectedInsurance: state.insuranceList.selectedInsurance,
    retailData: state.retailPrice.data,
    discountData: state.discountPrice.data,
    copayPrice: state.copayPrice.data,
    couponPrice: state.couponPrice.data,
    alternateList: state.alternateList.data,
    resetInfo: state.home.resetInfo,
    recentList: state.recentSearch.data,
    gtmInfo: state.gtmInfo.data,
    organizationInfo: state.organizationInfo.data,
    brandDetailsNew: state.brandDetailsNew.data,
    genericDetails: state.genericDetails.data,
    copayPriceIsProgress: state.copayPrice.isProgress,
  };
};

const actionCreators = {
  getProductPartialSearch: (value) =>
    homeActions.getProductPartialSearch(value),
  getProductDetails: (value) => homeActions.getProductDetails(value),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  getRetailPrice: (data) => homeActions.getRetailPrice(data),
  updateRetailPrice: (data) => homeActions.updateRetailPrice(data),
  getDiscountPrice: (data) => homeActions.getDiscountPrice(data),
  getCopayPrice: (params) => gaugeActions.getCopayPrice(params),
  getCouponPrice: (params) => gaugeActions.getCouponPrice(params),
  getAlternateList: (params) => gaugeActions.getAlternateList(params),
  resetBrandDetails: (params) => gaugeActions.resetBrandDetails(params),
  resetData: (value) => homeActions.resetData(value),
  resetZipStatus: () => homeActions.resetZipStatus(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  couponPriceReset: () => gaugeActions.couponPriceReset(),
  saveDosage: (value) => homeActions.saveDosage(value),
  saveForm: (value) => homeActions.saveForm(value),
  saveQuantity: (value) => homeActions.saveQuantity(value),
};

export default connect(mapStateToProps, actionCreators)(SearchMedication);
